module.exports = __webpack_public_path__ + "img/katarina_amenities_4.24b460f2.jpg";